import angular, { ILogService, ITimeoutService } from 'angular'
import moment from 'moment'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import {
  IBloqueCV,
  IEstadoCvStore,
  IModelAccion,
  IModelCurriculum,
  IPreguntaCV,
  IReporteCV,
} from 'src/model/candidato-api'
// import * as PDFDocument from 'pdfkit'
// import * as blobStream from "blob-stream"
import { test1 } from '../../../../pdfkit/test-pdfkit'

import jsPDF from 'jspdf'

import './panel-cv-pdf.scss'

class PanelCvPdfComponentCtrl {
  cv!: { cv: IModelCurriculum }

  report: IReporteCV
  $loading = false

  statesStore: IEstadoCvStore | undefined

  history = {
    list: [] as IModelAccion[],
    show: true,
  }

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelCvPrintComponentCtrl] onInit')

    this._leerCV().then(() => {
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then((responseTipos) => {
        this.statesStore = responseTipos.estados
      })
    })
  }

  $postLink() {
    $('body').css('overflow', 'auto')
  }

  private _leerCV() {
    this.$loading = true
    return this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then((reportResponse) => {
      this.report = reportResponse
      this.history.list = reportResponse.history.list

      this.$loading = false
    })
  }

  _refreshcv() {
    this.report = null

    this._leerCV()
  }

  toggleHistory() {
    this.history.show = !this.history.show
  }

  fichaPdf() {
    var doc = new jsPDF({
      orientation: 'p',
      unit: 'pt',
      format: 'a4',
      putOnlyUsedFonts: true,
    })
    doc.setFontSize(10)

    doc.text(`Application Date: ${moment(this.cv.cv.fcalta).format('lll')}`, 20, 20)

    doc.html('<hr/>')
    doc.setLineWidth(0.4)
    doc.line(20, 25, 200, 25)

    doc.text(
      [
        'hola',
        'segunda',
        'terceraterceraterceraterceraterceratercera terceraterceraterceraterceraterceratercera terceraterceraterceraterceraterceratercera terceraterceraterceraterceraterceratercera',
      ],
      20,
      50,
      { lineHeightFactor: 2 }
    )

    let lines = doc.splitTextToSize(
      'terceraterce \nraterceraterceraterce ratercera terceraterceratercer aterceraterceratercera terceraterceratercera terceratercerater cera terceraterceraterc eraterceratercerater cera',
      190
    )
    console.log('---->', lines)
    doc.text(lines, 20, 300)
    doc.text('=======', 20, 370 - 2.5)
    doc.text('=======', 20, 381.25 - 2.5)
    doc.text('=======', 20, 392.5 - 2.5)
    doc.text('=======', 20, 403.75 - 2.5)

    doc.text(['uno', 'dos', 'tres', 'cuatro'], 60, 370)

    console.log('===>', doc.getTextDimensions(lines))

    // doc.text(["hola", "segunda", "tercera"], 20, 60)

    // pintar los bloques
    this.report.bloques.forEach((b) => this.fichaPdfBloque(doc, b))

    window.open(URL.createObjectURL(doc.output('blob')))
  }

  private fichaPdfBloque(doc: jsPDF, b: IBloqueCV) {
    // pintar texto del bloque

    // pintar las preguntas
    b.pregsList.forEach((p) => this.fichaPdfPreg(doc, b, p))
  }

  private fichaPdfPreg(doc: jsPDF, b: IBloqueCV, preg: IPreguntaCV) {
    // texto preg
    doc.html(`<span>${preg.q.texto_en}</span>`)

    console.log('preg ---> ', preg.q.texto_en)
  }

  fichaPdf2() {
    var docPdf = new jsPDF()
    // doc.text(`Application Date: ${moment(this.cv.cv.fcalta).format('lll')}`, 20, 20);

    var _elDoc = this.$element.find('.print__content')

    if (_elDoc.length) {
      docPdf.html(_elDoc[0])
    }

    // doc.save(`Cv-${this.cv.cv.idcv}.pdf`);

    docPdf.autoPrint()

    let _blob = docPdf.output('blob') as any
    _blob.name = 'foooo'
    window.open(URL.createObjectURL(_blob))
  }

  fichaPdf4() {
    test1.testdoc()
  }

  // fichaPdf3() {

  //     const lorem = "TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM TEXTO LOREM "

  //     var doc = new PDFDocument()

  //     doc.registerFont('Roboto', 'fonts/Roboto-Regular.ttf');
  //     doc
  //         .font('Roboto')
  //         .text('And here is some wrapped text...', 100, 300)
  //         .fontSize(13)
  //         .moveDown()
  //         .text(lorem, {
  //             width: 412,
  //             align: 'justify',
  //             indent: 30,
  //             columns: 2,
  //             height: 300,
  //             ellipsis: true
  //         });

  //     doc.addPage();

  //     const stream = doc.pipe(blobStream());

  //     window.open(URL.createObjectURL(stream.toBlob()))
  // }
}

angular.module('candidato').component('panelCvPdf', {
  bindings: {
    cv: '<',
  },
  controller: PanelCvPdfComponentCtrl,
  // templateUrl: "panel-cv-pdf.component.html",
  template: require('./panel-cv-pdf.component.html'),
})
